























































































































































































































































































































































































































































































































































































































import MultiSelect from '@/components/MultiSelect.vue';
import {Generators, TableHeaders} from '@/interfaces/components-data';
import DatePicker from 'vue2-datepicker';
import '@/extensions';

import {
    FindFiltersParams,
    Promotions,
    Sales,
    SelectBox,
    StrategyOfPriceOpt,
    TaskInfoCalc,
} from '@/interfaces/global-data';
import {
    BaseFilterRoundingRules,
    CategoryStrategies,
    CompetitorsPriceStrategies,
    CompetitorsPricesView,
    GetTaskInfo,
    InternalCodeAndProductRange,
    ProductSegmentIdAndName,
    PromoFilterProducts,
    PromoFilterType,
    RoundingRulesFilter,
    Segment,
    Sku,
    TaskAndFile,
    TaskInfoFilterType,
} from '@/interfaces/server-data';
import Http from '@/mixins/http';
import {HttpExecutor} from '@/mixins/HttpExecutor';
import LocalData from '@/mixins/local-data';
import {BFormFile} from 'bootstrap-vue';
import moment from 'moment';
import {Component, Mixins, Prop} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import CSelect from '@/components/UI/CoefficientSelect.vue';
import Toast from '@/mixins/toast';
import CollapseCard from "@/components/UI/CollapseCard.vue"
import Card from '@/components/UI/Card.vue';
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';
import {TModuleType} from "@/pages/ModuleItems/data";

@Component({
    computed: {
        moment() {
            return moment
        },
        PromoFilterType() {
            return PromoFilterType
        },
        PromoFilterProducts() {
            return PromoFilterProducts
        }
    },
    components: {
        MultiSelect,
        vSelect,
        DatePicker,
        CollapseCard,
        Card,
        CSelect,
        SwitchWithLabel,
    },
    filters: {
        formatRulesDate: (v: any) => {
            if (v) {
                return moment(moment.utc(v)).local().format('DD/MM/YYYY HH:mm:ss');
            }
        },
    },
    methods: {
        replaceCommaFormatter(value) {
            return value.replace(',', '.')
        },
        replaceDecimalFormatter(value) {
            if (value == null) {
                return null
            } else {
                return parseFloat(value.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1').replace(',', '.'));
            }
        },
        replaceTxtToNumber(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/[^\d]/g, '').substring(0, 2);
            }
        },
        replaceTxtToNumberForRoundingRules(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/[^\d]/g, '');
            }
        },
    },
})
export default class RoundingPrices extends Mixins(Toast, Http, LocalData) {
    @Prop() readonly moduleType!: TModuleType;

    get moduleData(): Sales | Promotions {
        if (this.moduleType === 'promo') {
            return this.$promotions;
        } else {
            return this.$sales;
        }
    }

    file: File | null = null;
    productLineOptions: Array<SelectBox<string>> = [];
    productLineOptionsForFilter: Array<SelectBox<string>> = [];
    selectProductLine: string = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;

    productRangesArray: InternalCodeAndProductRange[] = [];

    defaultFilterValue = {value: -1, label: this.$t('shared.selectBox.all') as string};
    secondDefaultFilterValue = {value: -2, label: this.$t('shared.selectBox.empty') as string};

    selectProducts: PromoFilterProducts = {value: PromoFilterProducts.ALL, label: this.$t('shared.selectBox.all') as string}.value;
    selectProductsTypeForRecommends: PromoFilterProducts = PromoFilterProducts.ALL;
    selectProductsForPiRecommends: SelectBox<PromoFilterProducts> = {value: PromoFilterProducts.ALL, label: this.$t('shared.selectBox.all') as string};
    selectProductsForCdRecommends: SelectBox<PromoFilterProducts> = {value: PromoFilterProducts.ALL, label: this.$t('shared.selectBox.all') as string};
    selectProductsForIgRecommends: SelectBox<PromoFilterProducts> = {value: PromoFilterProducts.ALL, label: this.$t('shared.selectBox.all') as string};
    productFilterOptions: Array<SelectBox<PromoFilterProducts>> = [
        {value: PromoFilterProducts.ALL, label: this.$t('shared.selectBox.all') as string},
        {value: PromoFilterProducts.PROMO, label: this.$t('shared.selectBox.promo') as string},
        {value: PromoFilterProducts.REGULAR, label: this.$t('shared.selectBox.regular') as string},
    ];

    selectKVI: number = this.defaultFilterValue.value;
    selectKVIForNewProducts: number = this.defaultFilterValue.value;
    selectKVIRecommends: number = this.defaultFilterValue.value;
    kviValueForRecommends: number = -1;
    selectKVIForPiRecommends: SelectBox<number> = this.defaultFilterValue;
    selectKVIForCdRecommends: SelectBox<number> = this.defaultFilterValue;
    selectKVIForIgRecommends: SelectBox<number> = this.defaultFilterValue;
    kviOptions: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('shared.selectBox.all') as string},
        {value: 1, label: 'KVI'},
        {value: 0, label: this.$t('shared.selectBox.notKvi') as string},
    ];

    kviRecommendsOptions: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('shared.selectBox.all') as string},
        {value: 0, label: this.$t('shared.selectBox.gk') as string},
        {value: 1, label: this.$t('shared.selectBox.cvk') as string},
    ];

    selectCTM: string = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;
    selectCTMForNewProducts: string = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;
    ctmValueForRecommends: string | null = null;
    selectCTMForPiRecommends: SelectBox<string> = {value: 'all', label: this.$t('shared.selectBox.all') as string};
    selectCTMForCdRecommends: SelectBox<string> = {value: 'all', label: this.$t('shared.selectBox.all') as string};
    selectCTMForIgRecommends: SelectBox<string> = {value: 'all', label: this.$t('shared.selectBox.all') as string};
    ctmOptions: Array<SelectBox<string>> = [
        {value: 'all', label: this.$t('shared.selectBox.all') as string},
        {value: '1', label: 'CTM'},
        {value: '0', label: this.$t('shared.selectBox.notCtm') as string},
    ];

    selectSegmentPrice: Segment[] = [];
    selectSegmentPriceForNewProducts: Segment[] = [];
    segmentPriceValueForRecommends: Segment[] = [];
    selectPiRecommendsSegmentPrice: Segment[] = [];
    selectCdRecommendsSegmentPrice: Segment[] = [];
    selectIgRecommendsSegmentPrice: Segment[] = [];
    segmentPriceOptions: Array<SelectBox<Segment>> = [];
    segmentPriceOptionsForNewProducts: Array<SelectBox<Segment>> = [];
    segmentPriceForRecommendsOptions: Array<SelectBox<Segment>> = [];
    selectProductSegmentIdAndName: ProductSegmentIdAndName[] = [];
    selectNewProductSegmentIdAndName: ProductSegmentIdAndName[] = [];
    newProductSegmentIdAndNameOptions: Array<SelectBox<ProductSegmentIdAndName>> = [];
    productSegmentIdAndNameOptions: Array<SelectBox<ProductSegmentIdAndName>> = [];
    tableKey = 1;
    competitorTableKey = 1;

    selectKeyCharacteristicOne: string[] = [];
    selectKeyCharacteristicTwo: string[] = [];
    selectRecipeAttributes: string[] = [];
    selectTreatmentAttributes: number[] = [];

    selectKeyCharacteristicOneForNewProduct: string[] = [];
    selectKeyCharacteristicTwoForNewProduct: string[] = [];
    selectRecipeAttributesForNewProduct: string[] = [];
    selectTreatmentAttributesForNewProduct: number[] = [];

    keyCharacteristicOneOptions: Array<SelectBox<string>> = [];
    keyCharacteristicTwoOptions: Array<SelectBox<string>> = [];
    recipeAttributesOptions: Array<SelectBox<string>> = [];
    treatmentAttributesOptions: Array<SelectBox<number>> = [];

    keyCharacteristicOneForNewProductOptions: Array<SelectBox<string>> = [];
    keyCharacteristicTwoForNewProductOptions: Array<SelectBox<string>> = [];
    recipeAttributesForNewProductOptions: Array<SelectBox<string>> = [];
    treatmentAttributesForNewProductOptions: Array<SelectBox<number>> = [];

    taskInfo: TaskInfoCalc = {
        storeFormatOptions: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}],
        clusterOptions: [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}],
        groupsOfProduct: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        subcategories: [],
        subcategoriesDefault: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        psegemnts: [],
    };
    taskInfoRecommends: TaskInfoCalc = {
        storeFormatOptions: [],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [],
        clusterOptions: [],
        groupsOfProduct: [],
        subcategories: [],
        subcategoriesDefault: [],
        psegemnts: [],
    };
    taskInfoForRoundingRules: TaskInfoCalc = {
        storeFormatOptions: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}],
        clusterOptions: [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}],
        groupsOfProduct: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        subcategories: [],
        subcategoriesDefault: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        psegemnts: [],
    };
    promoSkuOfferRunning: boolean = false;
    searchable: boolean = true;
    usePromoRecommendsFilter: boolean = false;
    skuFilter: string = '';
    newProductsFilter: string = '';
    skuRecommendsFilter: string = '';
    skuList: Sku[] = [];
    skuListWithAllProducts: Sku[] = [];
    newProductsList: Sku[] = [];
    newProductsListWithAllProducts: Sku[] = [];
    fileResult: string = '';
    taskId: number = 0;
    trafficGenerators: Generators[] = [];
    incomeGenerators: Generators[] = [];
    cartDrivers: Generators[] = [];
    defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('shared.selectBox.all') as string}];
    promoFilter: Array<SelectBox<PromoFilterType>> = [
        {value: PromoFilterType.all, label: this.$t('shared.selectBox.all') as string},
        {value: PromoFilterType.ig, label: this.$t('shared.selectBox.revenueGenerator') as string},
        {value: PromoFilterType.cd, label: this.$t('shared.selectBox.cartDriver') as string},
        {value: PromoFilterType.pi, label: this.$t('shared.selectBox.penetrationIndex') as string},
    ];
    selectedPromoFilter: PromoFilterType = {value: PromoFilterType.all, label: this.$t('shared.selectBox.all') as string}.value;
    recommendsType: PromoFilterType = PromoFilterType.pi;
    skuListLimit: number = 20;
    newProductsListLimit: number = 20;

    taskData: TaskAndFile | null = null;

    competitors: CompetitorsPricesView[] = [];

    newProductsPagination: any = {
        pageSize: 20,
        current: 1,
    };

    rulesTableFields: TableHeaders[] = [
        {key: 'fileDownload', label: this.$t('shared.labels.actions') as string},
        {key: 'errors', label: this.$t('shared.labels.errors') as string},
        {key: 'uploadDate', label: this.$t('shared.labels.modifiedDate') as string},
        {key: 'user', label: this.$t('shared.labels.user') as string},
        {key: 'storeFormat', label: this.$t('shared.filters.storeFormatChannel') as string},
        {key: 'storeRegions', label: this.$t('shared.filters.storeRegion') as string},
        {key: 'storeCluster', label: this.$t('shared.filters.storeCluster') as string},
        {key: 'groupsOfProduct', label: this.$t('results.tableHeaders.productGroup') as string},
        {key: 'categories', label: this.$t('results.tableHeaders.productCategory') as string},
        {key: 'subcategories', label: this.$t('shared.parametersTab.subcategory') as string},
    ];

    newRulesTableFields: any[] = [
        {
            dataIndex: 'fileDownload',
            title: this.$t('shared.labels.actions') as string,
            scopedSlots: { customRender: 'fileDownload' },
        },
        {
            dataIndex: 'errors',
            title: this.$t('shared.labels.errors') as string,
            scopedSlots: { customRender: 'errors' }},
        {
            dataIndex: 'uploadDate',
            title: this.$t('shared.labels.modifiedDate') as string,
            customRender: (value: number) => moment(moment.utc(value)).local().format('DD/MM/YYYY HH:mm:ss'),
            scopedSlots: { filterDropdown: 'uploadDateFilter', filterIcon: "uploadDateFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'user',
            title: this.$t('shared.labels.user') as string,
            scopedSlots: { filterDropdown: 'userFilter', filterIcon: "userFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'storeFormat',
            title: this.$t('shared.filters.storeFormatChannel') as string,
            scopedSlots: { filterDropdown: 'storeFormatFilter', filterIcon: "storeFormatFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'storeRegions',
            title: this.$t('shared.filters.storeRegion') as string,
            scopedSlots: { filterDropdown: 'storeRegionsFilter', filterIcon: "storeRegionsFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'storeCluster',
            title: this.$t('shared.filters.storeCluster') as string,
            scopedSlots: {filterDropdown: 'storeClusterFilter', filterIcon: "storeClusterFilterIcon"},
            ellipsis: true,
        },
        {
            dataIndex: 'groupsOfProduct',
            title: this.$t('results.tableHeaders.productGroup') as string,
            scopedSlots: { filterDropdown: 'groupsOfProductFilter', filterIcon: "groupsOfProductFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'categories',
            title: this.$t('results.tableHeaders.productCategory') as string,
            scopedSlots: { filterDropdown: 'categoriesFilter', filterIcon: "categoriesFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'subcategories',
            title: this.$t('shared.parametersTab.subcategory') as string,
            scopedSlots: { filterDropdown: 'subcategoriesFilter', filterIcon: "subcategoriesFilterIcon" },
            ellipsis: true,
        },
    ];

    tableData: any = [];
    pagination: any = {
        current: 1,
        pageSize: 20,
    };

    loadingConfigs = false;
    marginalErrorText = ''
    marginalSkuErrorText = ''
    incorrectPeriodErrorText = '';
    globalNewProductIndividualMarginalErrorText = '';
    globalIndividualMarginalErrorText = '';
    globalNewProductIndividualMarginalBlockButton = false;
    globalLiftBlockButton = false;
    globalNewProductLiftBlockButton = false;
    globalIndividualMarginalBlockButton = false;
    globalIndividualPeriodPriceIncreaseLimitBlockButton = false;
    globalIndividualPriceIncreaseLimitBlockButton = false;

    downloadLastExcelHeaderByFilters: boolean = false;
    downloadLastExcelDetailByFilters = false;
    skuListPerPage = 20;
    newProductListPerPage: number = 20;
    skuListCurrentPage: number = 1;
    skuRecommendsListCurrentPage: number = 1;
    newProductsListCurrentPage: number = 1;
    skuListTotalRows: number = 0;
    newProductsListTotalRows: number = 0;

    onDropdownClosed: Function | null = null;
    needLoadSkuList: boolean = false;
    showBookmarks: boolean = true;
    showPromoRecommendsBookmarks: boolean = true;
    showMainFilters: boolean = true;
    showMainRecommendsFilters: boolean = true;
    needLoadNewProductList: boolean = false;
    firstDate: number = 0;
    lastDate: number = 0;
    calcModalShow: boolean = false;
    recalculatingRegularPricesModalShow: boolean = false;
    isActualProfitabilityCalculated: boolean = false;
    isRegularPricesProfitabilityCalculated: boolean = false;
    isDataRangeCalculated: boolean = false;
    isPriceCorridorCalculated: boolean = false;
    isFetchSkuListDownload: boolean = false;
    isFetchNewProductsListDownload: boolean = false;
    isLoadCompetitorPrices: boolean = false;
    kviSaveProcess: boolean = false;
    calcSkuActualProfitButtonDisabled: boolean = false;
    newProductsLastPage: number = 0;
    calcSkuLastPricesButtonDisabled: boolean = false;
    useFindKviRecommendsParam: boolean = false;
    isFiltersChangedForRecommends = 1;
    loadProgress: boolean = false;
    progressCounter: number = 0;
    rulesCurrentPage = 1;
    rulesTotalRows = 0;
    rulesPerPage = 20;
    rulesTableKey = 1;
    rulesDateRange: string[] = [];
    showDeleteFileModal: boolean = false;
    fileIdForDelete: number = -1;
    serverConfigTimeout: number | null = null;

    selectUserFio: string = 'All';
    usersFioList: Array<SelectBox<string>> = [];

    selectTradingFilter: SelectBox<number> = this.defaultFilterValue;
    tradingsFilterOptions: Array<SelectBox<number>> = [];

    selectCategoryFilter: number = this.defaultFilterValue.value;
    categoryFilterOptions: Array<SelectBox<number>> = [];

    selectGroupFilter: number = this.defaultFilterValue.value;
    groupFilterOptions: Array<SelectBox<number>> = [];

    selectSubcategoryFilter: number = this.defaultFilterValue.value;
    subcategoryFilterOptions: Array<SelectBox<number>> = [];

    selectFormatFilter: number = this.defaultFilterValue.value;
    formatFilterOptions: Array<SelectBox<number>> = [];

    selectRegionFilter: number = this.defaultFilterValue.value;
    regionFilterOptions: Array<SelectBox<number>> = [];

    selectClusterFilter: number = this.defaultFilterValue.value;
    clusterFilterOptions: Array<SelectBox<number>> = [];

    isFixPricePromo: boolean = false;

    private dropDownOpen = false;
    private dropDownOpenForRoundingRules = false;

    private onDropdownClosedForRoundingRules: Function | null = null;
    private httpExecutor: HttpExecutor = new HttpExecutor();

    private refreshRulesListId = -1;
    private needLoadFiltersForTable: boolean = true;

    handleFilter() {
        this.pagination.current = 1;

        this.fetchRulesList({
            currentPage: this.pagination.current,
        }, () => {});
    }

    refreshRoundingRulesListBySelectedFilters() {
        this.refreshRoundingRulesList()
    }

    refreshRoundingRulesList() {
        const oldRefreshId = this.refreshRulesListId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshRulesListId === timeoutId) {
                this.rulesCurrentPage = 1;
                const rules = this.$refs.rulesTable as any;
                if (typeof rules !== 'undefined') {
                    rules.refresh();
                }
                this.refreshRulesListId = -1;
            }
        }, 450);
        this.refreshRulesListId = timeoutId;
    }

    downloadRoundingRulesFile(fileId: number) {
        this.$http.get('/api/file/download-rules-file', {
            method: 'GET',
            responseType: 'blob',
            params: {
                ruleId: fileId,
            },
        })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Rules.xlsx');
                document.body.appendChild(link);
                link.click();
            })
            .catch(() => {
                this.showError(this.$t('shared.roundingPrices.errorDownloadRules') as string);
            });
    }

    showDeleteFileDialog(ruleId: number) {
        this.httpDeleteRoundingRulesFile(ruleId);
        this.refreshRoundingRulesList();
    }

    beforeDeleteFileDialog(fileId: number) {
        this.fileIdForDelete = fileId;
        this.showDeleteFileModal = true;
    }

    clearRoundingRulesFilters() {
        this.rulesDateRange = []
        this.selectUserFio = 'All';
        this.usersFioList = []
        this.selectCategoryFilter = this.defaultFilterValue.value;
        this.categoryFilterOptions = []
        this.selectGroupFilter = this.defaultFilterValue.value;
        this.groupFilterOptions = []
        this.selectSubcategoryFilter = this.defaultFilterValue.value;
        this.subcategoryFilterOptions = []
        this.selectFormatFilter = this.defaultFilterValue.value;
        this.formatFilterOptions = []
        this.selectRegionFilter = this.defaultFilterValue.value;
        this.regionFilterOptions = []
        this.selectClusterFilter = this.defaultFilterValue.value;
        this.clusterFilterOptions = []
        this.needLoadFiltersForTable = true;

        this.pagination.current = 1;

        this.fetchRulesList({
            currentPage: this.pagination.current,
        }, () => {});
    }

    rulesButtonDisable(): boolean {
        return this.file == null;
    }

    downloadRoundingErrorFile(fileId: number) {
        this.$http.get('/api/file/download-rules-error-file', {
            method: 'GET',
            responseType: 'blob',
            params: {
                ruleId: fileId,
            },
        })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Errors');
                document.body.appendChild(link);
                link.click();
            })
            .catch(() => {
                this.showError(this.$t('shared.competitorsPricesList.errorDownloadErrors') as string);
            });
    }

    fetchRulesList(ctx: any, callback: (items: any[]) => void) {
        const offset = (ctx.currentPage - 1) * this.pagination.pageSize;
        const filter = this.getRoundingListFilter()
        const tradingId = this.moduleData.selectMarket.id;
        this.httpLoadRoundingRules(filter, this.pagination.pageSize, offset)
            .then((res) => {
                    if (this.needLoadFiltersForTable) {
                        this.httpLoadRoundingRulesFilters(tradingId, this.moduleType === 'sales' ? 'SALE' : 'PROMO') // TODO уточнить и заменить
                            .then((r) => {
                                const result = r.data

                                const categories = result.categories.filter((i) => {
                                    return i.name !== '';
                                });
                                this.categoryFilterOptions = categories.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const groups = result.groupsOfProduct.filter((i) => {
                                    return i.name !== '';
                                });
                                this.groupFilterOptions = groups.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const subcategories = result.subcategories.filter((i) => {
                                    return i.name !== '';
                                });
                                this.subcategoryFilterOptions = subcategories.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const storeFormat = result.storeFormat.filter((i) => {
                                    return i.name !== '';
                                });
                                this.formatFilterOptions = storeFormat.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const regions = result.storeRegionValues.filter((i) => {
                                    return i.name !== '';
                                });
                                this.regionFilterOptions = regions.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const clusters = result.storeCluster.filter((i) => {
                                    return i.name !== '';
                                });
                                this.clusterFilterOptions = clusters.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                this.tradingsFilterOptions.unshift(this.defaultFilterValue);
                                this.categoryFilterOptions.unshift(this.defaultFilterValue);
                                this.groupFilterOptions.unshift(this.defaultFilterValue);
                                this.subcategoryFilterOptions.unshift(this.defaultFilterValue);
                                this.formatFilterOptions.unshift(this.defaultFilterValue);
                                this.regionFilterOptions.unshift(this.defaultFilterValue);
                                this.clusterFilterOptions.unshift(this.defaultFilterValue);

                                this.httpGetRoundingRulesUsersFio(tradingId)
                                    .then((response) => {
                                        this.usersFioList = response.data.map((i) => {
                                            return {value: i, label: i}
                                        });
                                        this.usersFioList.unshift({value: 'All', label: this.$t('shared.selectBox.all') as string});
                                    })
                                    .catch(() => {
                                        this.showError(this.$t('shared.roundingPrices.errorLoadUsers') as string);
                                    });

                                this.needLoadFiltersForTable = false;
                            })
                    }

                    const pagination = { ...this.pagination };
                    pagination.total = res.data.totalElements;
                    this.pagination = pagination;
                    this.rulesTotalRows = res.data.totalElements;
                    this.tableData = res.data.content;
                    callback(res.data.content);
                },
            )
            .catch(() => {
                callback([]);
                this.showError(this.$t('shared.roundingPrices.errorLoadRules') as string);
            });
    }

    getRoundingListFilter(): RoundingRulesFilter {
        const filter: RoundingRulesFilter = {tradingId: this.moduleData.selectMarket.id};

        filter.filterTypes = this.moduleType === 'sales' ? ['SALE'] : ['PROMO']

        if (this.rulesDateRange.length > 0) {
            filter.dateBefore = this.rulesDateRange[0]
            filter.dateAfter = this.rulesDateRange[1]
        }

        const userValue = this.selectUserFio
        if (userValue !== 'All') {
            filter.userFio = userValue
        }

        const storeFormatValue = this.selectFormatFilter
        if (storeFormatValue !== -1) {
            filter.storeFormat = storeFormatValue
        }

        const categoryValue = this.selectCategoryFilter
        if (categoryValue !== -1) {
            filter.category = categoryValue
        }

        const subcategory = this.selectSubcategoryFilter
        if (subcategory !== -1) {
            filter.subcategories = subcategory
        }

        const group = this.selectGroupFilter
        if (group !== -1) {
            filter.group = group
        }

        const cluster = this.selectClusterFilter
        if (cluster !== -1) {
            filter.storeCluster = cluster
        }

        const region = this.selectRegionFilter
        if (region !== -1) {
            filter.storeRegions = region
        }

        return filter;
    }

    tryFindRulesParams() {
        this.serverConfigTimeout = null;
        const [selectSeasons, selectRegions] = this.selectDataForRoundingRulesSeasonsRegions();
        const findParams = new FindFiltersParams();
        findParams.tradingId = this.moduleData.selectMarket.id;
        findParams.groupOfProduct = this.$roundingRules.groupOfProduct;
        findParams.category = this.$roundingRules.categoryOfProduct;
        findParams.subcategories = LocalData.filterNumberArrays(this.$roundingRules.subcategories)!!;
        findParams.storeCluster = this.$roundingRules.clusterSelected == null ? null : this.$roundingRules.clusterSelected;
        findParams.seasonValues = selectSeasons;
        findParams.storeRegionValues = selectRegions;
        findParams.storeFormat = this.$roundingRules.formatSelected;
        findParams.categoryStrategy = this.$roundingRules.categoryStrategy.value

        if (findParams.canLoadRoundingRules()) {
            this.loadingConfigs = true;
            this.httpFindRulesParams(findParams, this.moduleType === 'sales' ? 'SALE' : 'PROMO')
                .then((r) => {
                    const params = r.data;
                    this.$roundingRules.pennies = params.pennies
                    this.$roundingRules.allNewPricesWithoutPennies = params.allNewPricesWithoutPennies
                    this.$roundingRules.roundKviCompetitorPrice = params.roundKviCompetitorPrice
                    this.$roundingRules.roundPricesWithEqualCompStrategy = params.roundPricesWithEqualCompStrategy
                    this.$roundingRules.randomPennies = params.randomPennies
                    this.$roundingRules.bigDigit = params.bigDigit
                    this.$roundingRules.manualPennies = params.manualPennies

                    this.loadingConfigs = false
                })
                .catch((e) => {
                    this.loadingConfigs = false;
                    this.$log.error('Error occurred while loading configs', e);
                    this.showError(this.$t('shared.parametersTab.errorLoadParams') as string);
                })
        }
    }

    async saveRulesParams() {
        const filters = this.getRulesFilters();

        this.httpSaveRulesParams(filters)
            .then((r) => {
                this.$log.debug('Параметры сохранены', r.data);
                this.showInfo(this.$t('shared.parametersTab.saveParamsSuccess') as string);
            })
            .catch((e) => {
                this.showError(this.$t('shared.parametersTab.errorSaveCalcParams') as string + e);
            })
    }

    getRulesFilters(): BaseFilterRoundingRules {
        return {
            filterType: this.moduleType === 'sales' ? 'SALE' : 'PROMO',
            tradingId: this.moduleData.selectMarket.id,
            category: this.$roundingRules.categoryOfProduct,
            groupOfProduct: this.$roundingRules.groupOfProduct,
            seasonValues: this.$roundingRules.seasonSelected,
            buyerSegments: this.$roundingRules.buyerSegmentsList,
            storeRegionValues: this.$roundingRules.regionSelected,
            categoryStrategy: this.$roundingRules.categoryStrategy.value,
            storeFormat: this.$roundingRules.formatSelected,
            subcategories: this.$roundingRules.subcategories,
            productSegments: this.$roundingRules.productSegments,
            allNewPricesWithoutPennies: this.$roundingRules.allNewPricesWithoutPennies,
            storeCluster: this.$roundingRules.clusterSelected,
            pennies: this.$roundingRules.pennies,
            randomPennies: this.$roundingRules.randomPennies,
            roundKviCompetitorPrice: this.$roundingRules.roundKviCompetitorPrice,
            roundPricesWithEqualCompStrategy: this.$roundingRules.roundPricesWithEqualCompStrategy,
            bigDigit: this.$roundingRules.bigDigit,
            manualPennies: this.$roundingRules.manualPennies,
        }
    }

    uploadRoundingFile(event: Event) {
        if (!this.file) {
            this.showInfo(this.$t('shared.roundingPrices.selectFileRequired') as string);
            return;
        }

        const uploadFile = new FormData();
        this.loadProgress = true;
        const size = this.file.size;
        uploadFile.append('file', new Blob([this.file]), this.file.name);
        const self = this;
        const onUploadProgress = (e: any) => {
            const s = e.loaded / size;
            self.progressCounter = (s * 100) > 100 ? 100 : Math.round(s * 100);
        };

        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectDataForRoundingRulesSeasonsRegions();
        const filters: BaseFilterRoundingRules = {
            category: this.$roundingRules.categoryOfProduct,
            storeCluster: this.$roundingRules.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            storeFormat: this.$roundingRules.formatSelected,
            tradingId: this.moduleData.selectMarket.id,
            groupOfProduct: this.$roundingRules.groupOfProduct,
            categoryStrategy: this.$roundingRules.categoryStrategy.value,
            filterType: this.moduleType === 'sales' ? 'SALE' : 'PROMO',
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$roundingRules.subcategories)!!,
            productSegments: LocalData.filterNumberArrays(this.$roundingRules.productSegments)!!,
            allNewPricesWithoutPennies: this.$roundingRules.allNewPricesWithoutPennies,
            pennies: this.$roundingRules.pennies,
            randomPennies: this.$roundingRules.randomPennies,
            roundPricesWithEqualCompStrategy: this.$roundingRules.roundPricesWithEqualCompStrategy,
            roundKviCompetitorPrice: this.$roundingRules.roundKviCompetitorPrice,
            bigDigit: this.$roundingRules.bigDigit,
            manualPennies: this.$roundingRules.manualPennies,
        };

        uploadFile.append('filters', new Blob([JSON.stringify(filters)], {type: 'application/json'}));
        this.httpUploadRoundingRule(uploadFile, onUploadProgress)
            .then(() => {
                (this.$refs.fileinput as BFormFile).reset();
                this.file = null;
                // (this.$refs.rulesTable as any).refresh();
                this.$nextTick(() => {
                    this.loadProgress = false;
                    this.progressCounter = 0;
                });
            })
            .catch((e) => {
                (this.$refs.fileinput as BFormFile).reset();
                const dataWithoutStatus = e.response.data.replace(/[0-9]/g, '');
                this.showError(this.$t('shared.roundingPrices.errorUploadFile') as string + ' ' + dataWithoutStatus);
                this.loadProgress = false;
                this.progressCounter = 0;
                this.file = null;
                (this.$refs.fileinput as BFormFile).reset();
            });
        this.refreshRoundingRulesList()
    }

    mounted() {
        this.getFilterInfoForRoundingRules();

        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;
        this.fetchRulesList({
            currentPage: this.pagination.current,
        }, () => {});
    }

    onTableChange(pagination: any) {
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        this.pagination = pager;
        this.fetchRulesList({
            currentPage: this.pagination.current,
        }, () => {});
    }

    getFilterInfoForRoundingRules() {
        if (this.moduleData.selectMarket.id !== -1) {
            const self = this;
            (this.$refs.roundingRulesGroupSelectedRef as any).toggleLoading(true);
            (this.$refs.roundingRulesUpdateRegionsRef as any).toggleLoading(true);
            (this.$refs.roundingRulesUpdateSeasonsRef as any).toggleLoading(true);
            // (this.$refs.roundingRulesUpdateBuyerSegmentsRef as any).toggleLoading(true);
            (this.$refs.roundingRulesFormatSelectedRef as any).toggleLoading(true);
            (this.$refs.roundingRulesClasterSelectedRef as any).toggleLoading(true);
            (this.$refs.roundingRulesGroupOfProductRef as any).toggleLoading(true);
            (this.$refs.roundingRulesSubcategoriesRef as any).toggleLoading(true);
            (this.$refs.roundingRulesProductSegmentsRef as any).toggleLoading(true);
            this.getCategoryInfoForRoundingRules();
            self.getRegionInfoForRoundingRules();
            self.getFormatInfoForRoundingRules();
            // self.getBuyerSegmentForRoundingRules();
            self.getClusterInfoForRoundingRules();
            self.loadProductsGroupForRoundingRules();
            self.loadProductsSubcategoriesForRoundingRules();
            self.loadProductSegmentsForRoundingRules();
        }
    }

    loadProductsGroupForRoundingRules() {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.group))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.roundingRulesGroupOfProductRef as any).toggleLoading(false);
                }, 250);
                if (filterData.groups.length > 0) {
                    this.taskInfoForRoundingRules.groupsOfProduct = filterData.groups.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfoForRoundingRules.groupsOfProduct.unshift({value: null, label: this.$t('shared.selectBox.all') as string});
                } else {
                    this.$roundingRules.groupOfProduct = null;
                    this.taskInfoForRoundingRules.groupsOfProduct = [{value: null, label: this.$t('shared.selectBox.all') as string}];
                }
            })
            .catch(() => {
                this.showError(this.$t('shared.roundingPrices.errorLoadGroups') as string);
            })
    }

    loadProductsSubcategoriesForRoundingRules() {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.subcategory))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.roundingRulesSubcategoriesRef as any).toggleLoading(false);
                }, 250);
                this.taskInfoForRoundingRules.subcategories = filterData.subcategories.map((i) => {
                    return {value: i.id, label: i.name}
                });
                this.taskInfoForRoundingRules.subcategories.unshift({value: 0, label: this.$t('shared.selectBox.all') as string})
            })
            .catch(() => {
                this.showError(this.$t('shared.roundingPrices.errorLoadSubcategories') as string);
            })
    }

    resetDataForRoundingRules(type: TaskInfoFilterType) {
        switch (type) {
            case TaskInfoFilterType.group:
                this.$roundingRules.categoryOfProduct = null;
                this.$roundingRules.subcategories = this.defaultIntSelectBox.map(i => i.value);
                this.$roundingRules.formatSelected = null;
                this.$roundingRules.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$roundingRules.clusterSelected = null;
                this.$roundingRules.productSegments = this.defaultIntSelectBox.map(i => i.value);
                this.taskInfoForRoundingRules.categoryOptions = [{ value: null, label: this.$t("shared.selectBox.selectCategory") as string }];
                this.taskInfoForRoundingRules.subcategories = [];
                this.taskInfoForRoundingRules.psegemnts = [];
                this.taskInfoForRoundingRules.storeFormatOptions = [{ value: null, label: this.$t("shared.selectBox.all") as string }];
                this.taskInfoForRoundingRules.storeRegionOptions = [];
                this.taskInfoForRoundingRules.clusterOptions = [{ value: null, label: this.$t("shared.selectBox.selectCluster") as string }];
                this.getCategoryInfoForRoundingRules(null);
                this.loadProductsSubcategoriesForRoundingRules();
                this.loadProductSegmentsForRoundingRules();
                this.getFormatInfoForRoundingRules();
                this.getRegionInfoForRoundingRules();
                this.getClusterInfoForRoundingRules();
                break;
            case TaskInfoFilterType.category:
                this.$roundingRules.subcategories = this.defaultIntSelectBox.map(i => i.value);
                this.$roundingRules.formatSelected = null;
                this.$roundingRules.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$roundingRules.clusterSelected = null;
                this.$roundingRules.productSegments = this.defaultIntSelectBox.map(i => i.value);
                this.taskInfoForRoundingRules.subcategories = [];
                this.taskInfoForRoundingRules.psegemnts = [];
                this.taskInfoForRoundingRules.storeFormatOptions = [{ value: null, label: this.$t("shared.selectBox.all") as string }];
                this.taskInfoForRoundingRules.storeRegionOptions = [];
                this.taskInfoForRoundingRules.clusterOptions = [{ value: null, label: this.$t("shared.selectBox.selectCluster") as string }];
                this.loadProductsSubcategoriesForRoundingRules();
                this.loadProductSegmentsForRoundingRules();
                this.getFormatInfoForRoundingRules();
                this.getRegionInfoForRoundingRules();
                this.getClusterInfoForRoundingRules();
                break;
            case TaskInfoFilterType.subcategory:
                this.$roundingRules.formatSelected = null;
                this.$roundingRules.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$roundingRules.clusterSelected = null;
                this.$roundingRules.productSegments = this.defaultIntSelectBox.map(i => i.value);
                this.taskInfoForRoundingRules.psegemnts = [];
                this.taskInfoForRoundingRules.storeFormatOptions = [{ value: null, label: this.$t("shared.selectBox.all") as string }];
                this.taskInfoForRoundingRules.storeRegionOptions = [];
                this.taskInfoForRoundingRules.clusterOptions = [{ value: null, label: this.$t("shared.selectBox.selectCluster") as string }];
                this.loadProductSegmentsForRoundingRules();
                this.getFormatInfoForRoundingRules();
                this.getRegionInfoForRoundingRules();
                this.getClusterInfoForRoundingRules();
                break;
            case TaskInfoFilterType.p_segemnt:
                this.$roundingRules.formatSelected = null;
                this.$roundingRules.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$roundingRules.clusterSelected = null;
                this.taskInfoForRoundingRules.storeFormatOptions = [{value: null, label: this.$t('shared.selectBox.all') as string}];
                this.taskInfoForRoundingRules.storeRegionOptions = [];
                this.taskInfoForRoundingRules.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.getFormatInfoForRoundingRules();
                this.getRegionInfoForRoundingRules();
                this.getClusterInfoForRoundingRules();
                break;
            case TaskInfoFilterType.format:
                this.$roundingRules.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$roundingRules.clusterSelected = null;
                this.taskInfoForRoundingRules.storeRegionOptions = [];
                this.taskInfoForRoundingRules.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.loadProductSegmentsForRoundingRules();
                this.getRegionInfoForRoundingRules();
                this.getClusterInfoForRoundingRules();
                break;
            case TaskInfoFilterType.region:
                this.$roundingRules.clusterSelected = null;
                this.taskInfoForRoundingRules.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.loadProductSegmentsForRoundingRules();
                this.getClusterInfoForRoundingRules();
                break;
        }
    }

    updateProductGroupForRoundingRules(groupOfProduct: number | null) {
        if (groupOfProduct !== this.$roundingRules.groupOfProduct) {
            this.$roundingRules.groupOfProduct = groupOfProduct;

            this.saveRoundingRules();
            this.resetDataForRoundingRules(TaskInfoFilterType.group)
        }
    }

    updateProductCategoryForRoundingRules(category: number | null) {
        if (category !== this.$roundingRules.categoryOfProduct) {
            this.$roundingRules.categoryOfProduct = category;
            this.resetDataForRoundingRules(TaskInfoFilterType.category);
            this.saveRoundingRules();
        }
    }

    getCategoryInfoForRoundingRules(cb: any = null) {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.category))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.roundingRulesGroupSelectedRef as any).toggleLoading(false);
                    (this.$refs.roundingRulesUpdateSeasonsRef as any).toggleLoading(false);
                }, 250);
                if (filterData.categories.length > 0) {
                    this.taskInfoForRoundingRules.categoryOptions = filterData.categories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfoForRoundingRules.categoryOptions.unshift({
                        value: null,
                        label: this.$t('shared.selectBox.selectCategory') as string,
                    });
                } else {
                    this.$roundingRules.categoryOfProduct = null;
                    this.taskInfoForRoundingRules.categoryOptions = [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}];
                    this.resetDataForRoundingRules(TaskInfoFilterType.category);
                }
                if (typeof cb === 'function') {
                    cb();
                }
            })
            .catch(() => {
                this.showError(this.$t('shared.roundingPrices.errorLoadCategories') as string);
            })
    }

    updateSubcategoriesForRoundingRules(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$roundingRules.subcategories)) {
            // this.resetPriceCorridorForSetupMaster();
            this.$roundingRules.subcategories = list;

            this.onDropdownClosedForRoundingRules = () => {
                // this.updatePriceCorridorForSetupMaster();
                this.saveRoundingRules();
                this.resetDataForRoundingRules(TaskInfoFilterType.subcategory);
            };
            if (!this.dropDownOpenForRoundingRules) {
                this.onDropdownClosedForRoundingRules.apply(this.dropDownOpenForRoundingRules);
                this.onDropdownClosedForRoundingRules = null;
            }
        } else if (this.$roundingRules.subcategories[0] === 0) {
            this.$roundingRules.subcategories = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateProductSegmentsForRoundingRules(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$roundingRules.productSegments)) {
            // this.resetPriceCorridorForSetupMaster();
            this.$roundingRules.productSegments = list;

            this.onDropdownClosedForRoundingRules = () => {
                // this.updatePriceCorridorForSetupMaster();
                this.saveRoundingRules();
                this.resetDataForRoundingRules(TaskInfoFilterType.p_segemnt);
            };
            if (!this.dropDownOpenForRoundingRules) {
                this.onDropdownClosedForRoundingRules.apply(this.dropDownOpenForRoundingRules);
                this.onDropdownClosedForRoundingRules = null;
            }
        } else if (this.$roundingRules.productSegments[0] === 0) {
            this.$roundingRules.productSegments = this.defaultIntSelectBox.map(i => i.value);
        }
    }

    updateClusterForRoundingRules(cluster: number | null) {
        if (cluster !== this.$roundingRules.clusterSelected) {
            this.$roundingRules.clusterSelected = cluster;

            this.resetDataForRoundingRules(TaskInfoFilterType.cluster);
            this.saveRoundingRules();
        }
    }

    updateFormatForRoundingRules(format: number | null) {
        if (format !== this.$roundingRules.formatSelected) {
            this.$roundingRules.formatSelected = format;

            this.resetDataForRoundingRules(TaskInfoFilterType.format);
            this.saveRoundingRules();
        }
    }

    updateRegionsForRoundingRules(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$roundingRules.regionSelected)) {
            // this.resetPriceCorridorForSetupMaster();
            this.$roundingRules.regionSelected = list;
            /*this.taskInfoForSetupMaster.storeRegionOptions.filter((region) => list.includes(region.value!!))
                    .forEach((region) => {
                        this.setupMasterRegionNames = region.label
                    });*/
            this.onDropdownClosedForRoundingRules = () => {
                this.saveRoundingRules();
                // this.updatePriceCorridorForSetupMaster();
                this.resetDataForRoundingRules(TaskInfoFilterType.region);
            };
            if (!this.dropDownOpenForRoundingRules) {
                this.onDropdownClosedForRoundingRules.apply(this.dropDownOpenForRoundingRules);
                this.onDropdownClosedForRoundingRules = null;
            }
        } else if (this.$roundingRules.regionSelected[0] === 0) {
            this.$roundingRules.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateBuyerSegments(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$promo.buyerSegmentsList)) {
            this.$promo.buyerSegmentsList = list;
        } else if (this.$promo.buyerSegmentsList[0] === 0) {
            this.$promo.buyerSegmentsList = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateSeasonsForRoundingRules(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$roundingRules.seasonSelected)) {
            // this.resetPriceCorridorForSetupMaster();
            this.$roundingRules.seasonSelected = list;
            this.onDropdownClosedForRoundingRules = () => {
                // this.priceCorridorInfoForSetupMaster();
                this.saveRoundingRules();
            };
            if (!this.dropDownOpenForRoundingRules) {
                this.onDropdownClosedForRoundingRules.apply(this.dropDownOpenForRoundingRules);
                this.onDropdownClosedForRoundingRules = null;
            }
        } else if (this.$roundingRules.seasonSelected[0] === 0) {
            this.$roundingRules.seasonSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    showRoundPricesWithEqualCompStrategy(): boolean {
        return this.$promo.competitorsPriceStrategy.value === CompetitorsPriceStrategies.EQUALS;
    }

    tryAutomaticallyFindParams() {
        if (this.$promo.categoryStrategy.value !== CategoryStrategies.EMPTY) {
            this.tryFindParams()
        }
    }

    tryFindParams() {
        const [selectSeasons, selectRegions] = this.selectData();
        const findParams = new FindFiltersParams();
        findParams.tradingId = this.moduleData.selectMarket.id;
        findParams.groupOfProduct = this.$promo.groupOfProduct;
        findParams.category = this.$promo.categoryOfProduct;
// tslint:disable-next-line: no-non-null-assertion
        findParams.subcategories = LocalData.filterNumberArrays(this.$promo.subcategories)!!;
// tslint:disable-next-line: no-non-null-assertion
        findParams.productSegments = LocalData.filterNumberArrays(this.$promo.productSegments)!!;
        findParams.storeCluster = this.$promo.clusterSelected;
        findParams.seasonValues = selectSeasons;
        findParams.storeRegionValues = selectRegions;
        findParams.storeFormat = this.$promo.formatSelected;
        findParams.categoryStrategy = this.$promo.categoryStrategy.value
        if (findParams.canLoad()) {
            this.loadingConfigs = true;
            this.loadCommonParams(findParams)
                .then(() => this.loadPromoParams(findParams))
                .then(() => this.loadCommonIndividual(findParams))
                .then(() => this.loadPromoIndividual(findParams))
                .catch((e) => {
                    this.loadingConfigs = false;
                    this.$log.error('Error occurred while loading configs', e);
                    this.showError(this.$t('shared.roundingPrices.errorLoadCalcParams') as string);
                })
                .finally(() => {
                    this.savePromo();
                    this.loadingConfigs = false;
                })
            ;
        }
    }

    selectInternalCodesRecomendations(): string[] {
        let result: string[] = [];
        if (this.usePromoRecommendsFilter) {
            const recommendsType = this.selectedPromoFilter;
            if (recommendsType === PromoFilterType.cd) {
                result = this.cartDrivers.map((i) => i.internalCode);
            } else if (recommendsType === PromoFilterType.ig) {
                result = this.incomeGenerators.map((i) => i.internalCode);
            } else if (recommendsType === PromoFilterType.pi) {
                result = this.trafficGenerators.map((i) => i.internalCode);
            }
        }
        return result;
    }

    selectData(): [number[], number[], number[], string[], string | null, Segment[] | null, string[] | null] {
        const selectSeasons: number[] = (this.$promo.seasonSelected.length === 0 || (this.$promo.seasonSelected.length === 1 && this.$promo.seasonSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$promo.seasonSelected)!!;
        const selectRegions: number[] = (this.$promo.regionSelected.length === 0 || (this.$promo.regionSelected.length === 1 && this.$promo.regionSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$promo.regionSelected)!!;

        const selectBuyerSegment: number[] = (this.$promo.buyerSegmentsList.length === 0 || (this.$promo.buyerSegmentsList.length === 1 && this.$promo.buyerSegmentsList[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$promo.buyerSegmentsList)!!;
        const selectedSku: string[] = (this.$promo.selectedSkuList.length === 0 || this.$promo.selectedSkuList.length === 1 && this.$promo.selectedSkuList[0].value === null)
            ? []
            : (this.$promo.selectedSkuList).filter((item) => item.value !== null).map((item) => {
                return (item.value);
            });
        const ctm: string | null = this.selectCTM === 'all' ? null : this.selectCTM;
        this.selectSegmentPrice = this.selectSegmentPrice.filter((item) => {
            return item.name !== 'All'
        });
        const priceSegments: Segment[] | null = this.selectSegmentPrice.map((i) => {
            return {name: i.name, minSegment: i.minSegment, maxSegment: i.maxSegment};
        });
        const recommendsCodes: string[] = this.selectInternalCodesRecomendations();
        return [selectSeasons, selectRegions, selectBuyerSegment, selectedSku, ctm, priceSegments, recommendsCodes];
    }

    selectDataForRoundingRulesSeasonsRegions(): [number[], number[], number[]] {
        const selectSeasons: number[] = (this.$roundingRules.seasonSelected.length === 0 || (this.$roundingRules.seasonSelected.length === 1 && this.$roundingRules.seasonSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$roundingRules.seasonSelected)!!;
        const selectRegions: number[] = (this.$roundingRules.regionSelected.length === 0 || (this.$roundingRules.regionSelected.length && this.$roundingRules.regionSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$roundingRules.regionSelected)!!;
        const selectBuyerSegment: number[] = (this.$roundingRules.buyerSegmentsList.length === 0 || (this.$roundingRules.buyerSegmentsList.length === 1 && this.$roundingRules.buyerSegmentsList[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$roundingRules.buyerSegmentsList)!!;
        // const ctm: string | null = this.selectCTM.value === 'all' ? null : this.selectCTM.value;

        this.$log.log(selectRegions)
        return [selectSeasons, selectRegions, selectBuyerSegment];
    }

    getRegionInfoForRoundingRules() {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.region))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.roundingRulesUpdateRegionsRef as any).toggleLoading(false);

                }, 500);

                this.taskInfoForRoundingRules.storeRegionOptions = filterData.storeRegion.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch(() => {
                this.showError(this.$t('shared.roundingPrices.errorLoadRegions') as string);
            });
    }

    getFormatInfoForRoundingRules() {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.format))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.roundingRulesFormatSelectedRef as any).toggleLoading(false);
                }, 500);

                this.taskInfoForRoundingRules.storeFormatOptions = filterData.storeFormat.map((i) => {
                    return {value: i.id, label: i.name};
                });
                this.taskInfoForRoundingRules.storeFormatOptions = [{
                    value: null,
                    label: this.$t('shared.selectBox.all') as string,
                }, ...this.taskInfoForRoundingRules.storeFormatOptions];

            })
            .catch(() => {
                this.showError(this.$t('shared.roundingPrices.errorLoadFormats') as string);
            });
    }

    getClusterInfoForRoundingRules() {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.cluster))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.roundingRulesClasterSelectedRef as any).toggleLoading(false);
                }, 500);

                this.taskInfoForRoundingRules.clusterOptions = filterData.storeCluster.map((i) => {
                    return {value: i.id, label: i.name};
                });
                this.taskInfoForRoundingRules.clusterOptions = [{
                    value: null,
                    label: this.$t('shared.selectBox.all') as string,
                }, ...this.taskInfoForRoundingRules.clusterOptions];
            })
            .catch(() => {
                this.showError(this.$t('shared.roundingPrices.errorLoadClusters') as string);
            });
    }

    loadProductSegmentsForRoundingRules() {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.p_segemnt))
            .then(data => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.roundingRulesProductSegmentsRef as any).toggleLoading(false);
                }, 250);
                this.taskInfoForRoundingRules.psegemnts = filterData.psegments.map(i => {
                    return {
                        label: i.name,
                        value: i.id
                    };
                });
                this.taskInfo.psegemnts.unshift({ value: 0, label: this.$t('shared.selectBox.all') as string })
            })
            .catch(() => {
                this.showError(this.$t('shared.roundingPrices.errorLoadSegments') as string);
            });
    }

    get saveStateForRoundingRules(): boolean {
        return (this.moduleData.selectMarket.id == null)
    }

    onMultiSelectToggle(open: boolean) {
        this.dropDownOpen = open;
        if (!open) {
            if (this.onDropdownClosed != null) {
                this.onDropdownClosed.apply(open);
            }
        }
    }

    onTabsChanged(evt: string) {
        if (evt === "systemTab") {
            (this.$refs.competitorsListRef as any).activate();
        } else {
            (this.$refs.competitorsListRef as any).deactivate();
        }
    }

    private getTaskInfoForRoundingRules(taskType: TaskInfoFilterType): GetTaskInfo {
        const selectRegions: number[] = (this.$roundingRules.regionSelected.length === 0 || (this.$roundingRules.regionSelected.length && this.$roundingRules.regionSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$roundingRules.regionSelected)!!;
        return {
            type: taskType,
            tradingId: this.moduleData.selectMarket.id,
            categories: this.$roundingRules.categoryOfProduct == null || this.$roundingRules.categoryOfProduct <= 0 ? null : [this.$roundingRules.categoryOfProduct],
            groups: this.$roundingRules.groupOfProduct == null || this.$roundingRules.groupOfProduct <= 0 ? null : [this.$roundingRules.groupOfProduct],
            subcategory: LocalData.filterNumberArrays(this.$roundingRules.subcategories, true),
            segments: null,
            storeFormat: this.$roundingRules.formatSelected == null || this.$roundingRules.formatSelected <= 0 ? null : [this.$roundingRules.formatSelected],
            storeCluster: this.$roundingRules.clusterSelected == null || this.$roundingRules.clusterSelected <= 0 ? null : [this.$roundingRules.clusterSelected],
            storeRegion: selectRegions,
            byReports: false,
        }
    }

    private loadCommonParams(findFilterParams: FindFiltersParams): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.httpExecutor.executeHttp(this.httpFindBaseParams, findFilterParams)
                .then((r) => {
                    if (!r.ignore) {
                        const resp = r.response;
                        if (resp.status === 200) {
                            const filter = resp.data.filters;
                            this.applyCalcFilters(this.$promo, filter);
                        }
                    }
                    resolve(!r.ignore);
                })
                .catch((e) => {
                    reject(e);
                    this.showError(this.$t('shared.roundingPrices.errorLoadParams') as string);
                })
        });
    }

    private loadPromoParams(findFilterParams: FindFiltersParams): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.httpExecutor.executeHttp(this.httpFindPromoParams, findFilterParams)
                .then((r) => {
                    if (!r.ignore) {
                        const resp = r.response;
                        if (resp.status === 200) {
                            const filter = resp.data.filters;
                            this.applyPromoFilters(this.$promo, filter);
                        }
                    }
                    resolve(!r.ignore)
                })
                .catch((e) => {
                    reject(e);
                    this.showError(this.$t('shared.roundingPrices.errorLoadParams') as string);
                });
        });
    }

    private loadCommonIndividual(findFilterParams: FindFiltersParams): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.httpExecutor.executeHttp(this.httpLoadBaseIndividual, findFilterParams)
                .then((r) => {
                    if (!r.ignore) {
                        const resp = r.response;
                        if (resp.status === 200) {
                            const params = resp.data;
                            this.applyBaseIndividualConfig(this.$promo, params);
                        }
                    }
                    resolve(!r.ignore);
                })
                .catch(() => {
                    this.showError(this.$t('shared.roundingPrices.errorLoadIndParams') as string);
                })
        });
    }

    private loadPromoIndividual(findFilterParams: FindFiltersParams): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.httpExecutor.executeHttp(this.httpLoadPromoIndividual, findFilterParams)
                .then((r) => {
                    if (!r.ignore) {
                        const resp = r.response;
                        if (resp.status === 200) {
                            const params = resp.data;
                            this.applyPromoIndividualConfig(this.$promo, params);
                        }
                    }
                    resolve(!r.ignore)
                })
                .catch(() => {
                    this.showError(this.$t('shared.roundingPrices.errorLoadIndParams') as string);
                });
        })
    }

    get isCategorySelectedForRoundingRules(): boolean {
        return this.$roundingRules.categoryOfProduct != null && this.$roundingRules.categoryOfProduct!! > 0;
    }

    get isSubcategorySelectedForRoundingRules(): boolean {
        const subcategories = LocalData.filterNumberArrays(this.$roundingRules.subcategories);
        return subcategories != null && subcategories.length!! > 0;
    }

    get isGroupSelectedForRoundingRules(): boolean {
        return this.$roundingRules.groupOfProduct != null && this.$roundingRules.groupOfProduct!! > 0;
    }
}
